import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { useIntl } from 'react-intl'
import { any, bool, func, number } from 'prop-types'

import { authenticationMessages, uppercaseMessages } from '../../../translations'
import { Button } from '../../Button'
import { useFormContext } from '../../Form'
import {
  EmailInput,
  PasswordInput,
  PasswordConfirmationInput,
  FirstNameInput,
  LastNameInput,
  UsernameInput,
  Recaptcha,
} from '../Inputs'
import { SubmitButton } from '../SubmitButton'
import { TermsOfService } from './TermsOfService'

const StyledButtonWrapper = styled.div`
  text-align: center;
  margin: 1.25rem 0;
`

const StyledSubmitButton = styled(SubmitButton)`
  margin-top: 1rem;
`

const StyledButton = styled(Button)`
  width: 100%;
  font-weight: bold;
  color: ${({ theme }) => (theme.isDark ? theme.darkGrey : theme.darkTextColor)};
`

export const SignUpInputs = ({
  signUpStep,
  setSignUpStep,
  clearCaptcha,
  setClearCaptcha,
  signUpErrors,
}) => {
  const { formatMessage } = useIntl()
  const { setFieldValue, values, errors, isSubmitting, setSubmitting } = useFormContext()
  const captchaRef = useRef()

  useEffect(() => {
    if (signUpStep === 1 && clearCaptcha) {
      setFieldValue('captcha', null)
      setClearCaptcha(false)
    }
  }, [signUpStep, clearCaptcha, values, errors])

  useEffect(() => {
    if (isSubmitting && (errors || signUpErrors)) {
      setSubmitting(false)
      captchaRef.current.reset()
    }
  }, [signUpErrors])

  const handleCaptcha = (value) => {
    setFieldValue('captcha', value)
  }

  const disableNext =
    errors.email ||
    errors.password ||
    errors.passwordConfirmation ||
    !values.email ||
    !values.password ||
    !values.passwordConfirmation

  if (signUpStep === 0) {
    return (
      <>
        <EmailInput />
        <PasswordInput showValidations />
        <PasswordConfirmationInput />
        <StyledButton
          size='medium'
          intent='lightBlue'
          disabled={disableNext}
          onClick={() => {
            setSignUpStep(1)
          }}
        >
          {formatMessage(uppercaseMessages.next)}
        </StyledButton>
      </>
    )
  }
  return (
    <>
      <FirstNameInput />
      <LastNameInput />
      <UsernameInput />
      <TermsOfService />
      <StyledButtonWrapper>
        <Recaptcha handleCaptcha={handleCaptcha} setRef={captchaRef} />
        <StyledSubmitButton checkCaptcha>
          {formatMessage(authenticationMessages.createAccount)}
        </StyledSubmitButton>
      </StyledButtonWrapper>
    </>
  )
}

SignUpInputs.propTypes = {
  signUpStep: number,
  setSignUpStep: func,
  clearCaptcha: bool,
  setClearCaptcha: func,
  signUpErrors: any,
}
